import { c as _c } from "react/compiler-runtime";
import { Image } from '@/app/components/media/image';
import { getImageAlt, isPortraitImage } from '@/app/lcv/components/sections/news-activities/details/content-rows/utils';
import { DetailsContentRow } from '@/app/lcv/components/sections/news-activities/details/details-content-row';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import type { ComponentNewsSingleImage } from '@/types/tis-cms/types';
export const SingleImageContent = t0 => {
  const $ = _c(20);
  const {
    data,
    title,
    testId
  } = t0;
  const image = data.image;
  if (!image?.url) {
    return null;
  }
  let T0;
  let t1;
  if ($[0] !== image) {
    const isPortrait = isPortraitImage(image);
    T0 = DetailsContentRow;
    t1 = cn("col-span-12 col-start-1", {
      "md:col-start-2 lg:col-span-10 lg:col-start-2 xl:col-span-10 xl:col-start-2": !isPortrait,
      "md:col-span-8 md:col-start-3 xl:col-span-6 xl:col-start-4": isPortrait
    });
    $[0] = image;
    $[1] = T0;
    $[2] = t1;
  } else {
    T0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== testId) {
    t2 = createDataAttributes({
      test: testId
    });
    $[3] = testId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = image.url;
  let t4;
  if ($[5] !== image || $[6] !== title) {
    t4 = getImageAlt(image, title);
    $[5] = image;
    $[6] = title;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = image.width ?? 640;
  const t6 = image.height ?? 360;
  let t7;
  if ($[8] !== image.url || $[9] !== t4 || $[10] !== t5 || $[11] !== t6) {
    t7 = <Image src={t3} alt={t4} width={t5} height={t6} layout="ratio" aspectRatio="calculate" sizes="(min-width: 1024px) 680px, 90vw" />;
    $[8] = image.url;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t2 || $[14] !== t7) {
    t8 = <figure className="bg-silver-50 lg:after-overlay rounded-base-md relative block size-full overflow-hidden" {...t2}>{t7}</figure>;
    $[13] = t2;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== T0 || $[17] !== t1 || $[18] !== t8) {
    t9 = <T0 contentClassName={t1}>{t8}</T0>;
    $[16] = T0;
    $[17] = t1;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};